import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';

// import ngx-translate and the http loader
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// signature-pad
import { SignaturePadModule } from 'angular2-signaturepad';

// select
import { NgSelectModule } from '@ng-select/ng-select';

import { AppComponent } from './app.component';
import { ErrorComponent } from './error/error.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { NavMenuComponent } from './shared/nav-menu/nav-menu.component';
import { ProgressBarComponent } from './shared/progress-bar/progress-bar.component';
import { TitleComponent } from './shared/title/title.component';
import { NavigationButtonsComponent } from './shared/navigation-buttons/navigations-buttons.component';
import { PhoneNumberComponent } from './shared/phone-number/phone-number.component';
import { DateOfBirthComponent } from './shared/date-of-birth/date-of-birth.component';
import { FullNameComponent } from './shared/full-name/full-name.component';
import { AddressComponent } from './shared/address/address.component';
import { EmailAddressComponent } from './shared/email-address/email-address.component';
import { RelationshipComponent } from './shared/relationship/relationship.component';
import { SummaryComponent } from './components/authorize/shared/summary.component';
import { SelectLanguageComponent } from './shared/select-language/select-language.component';

import { HomeComponent } from './components/home/home.component';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { StudentComponent } from './components/student/student.component';
import { StudentAddressComponent } from './components/student-address/student-address.component';
import { FirstGuardianComponent } from './components/guardians/first-guardian/first-guardian.component';
import { EmergencyContactComponent } from './components/emergency-contact/emergency-contact.component';
import { ProviderAndPharmacyComponent } from './components/provider-and-pharmacy/provider-and-pharmacy.component';
import { HipaaComponent } from './components/hipaa/hipaa.component';
import { InsuranceComponent } from './components/insurance/insurance.component';
import { MyNortonChartComponent } from './components/my-norton-chart/my-norton-chart.component';
import { MedicalAndSurgicalHistoryComponent } from './components/medical-and-surgical-history/medical-and-surgical-history.component';
import { TobaccoAlcoholComponent } from './components/tobacco-alcohol/tobacco-alcohol.component';
import { PermissionToExamineComponent } from './components/permission-to-examine/permission-to-examine.component';
import { AuthorizeComponent } from './components/authorize/authorize.component';
import { SignatureComponent } from './components/signature/signature.component';
import { ThankYouComponent } from './components/thank-you/thank-you.component';

@NgModule({
  declarations: [
    AppComponent,
    ErrorComponent,
    PageNotFoundComponent,
    NavMenuComponent,
    ProgressBarComponent,
    TitleComponent,
    NavigationButtonsComponent,
    PhoneNumberComponent,
    DateOfBirthComponent,
    FullNameComponent,
    AddressComponent,
    EmailAddressComponent,
    RelationshipComponent,
    SummaryComponent,
    SelectLanguageComponent,

    HomeComponent,
    WelcomeComponent,
    StudentComponent,
    StudentAddressComponent,
    FirstGuardianComponent,
    EmergencyContactComponent,
    ProviderAndPharmacyComponent,
    HipaaComponent,
    InsuranceComponent,
    MyNortonChartComponent,
    MedicalAndSurgicalHistoryComponent,
    TobaccoAlcoholComponent,
    PermissionToExamineComponent,
    AuthorizeComponent,
    SignatureComponent,
    ThankYouComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    SignaturePadModule,
    NgSelectModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    RouterModule.forRoot([
      { path: '', component: HomeComponent, pathMatch: 'full' },
      { path: 'mock/:mock', component: HomeComponent, pathMatch: 'full' }, // <-- testing purposes only
      { path: 'welcome', component: WelcomeComponent },
      { path: 'student', component: StudentComponent },
      { path: 'student-address', component: StudentAddressComponent },
      { path: 'first-guardian', component: FirstGuardianComponent },
      { path: 'emergency-contact', component: EmergencyContactComponent },
      { path: 'provider-and-pharmacy', component: ProviderAndPharmacyComponent },
      { path: 'hipaa', component: HipaaComponent },
      { path: 'insurance', component: InsuranceComponent },
      { path: 'my-norton-chart', component: MyNortonChartComponent },
      { path: 'medical-and-surgical-history', component: MedicalAndSurgicalHistoryComponent },
      { path: 'tobacco-alcohol', component: TobaccoAlcoholComponent },
      { path: 'permission-to-examine', component: PermissionToExamineComponent },
      { path: 'authorize', component: AuthorizeComponent },
      { path: 'signature', component: SignatureComponent },
      { path: 'thank-you', component: ThankYouComponent },
      { path: 'error', component: ErrorComponent },
      { path: '**', component: PageNotFoundComponent }
    ])
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/");
}
